/** Local time only for book refresh UI (e.g. 10:25:26). */
export function formatRefreshTimestamp(timestampMs) {
  if (timestampMs == null || Number.isNaN(Number(timestampMs))) return "";
  const d = new Date(Number(timestampMs));
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}
